<p-panel
  *ngIf="!isPublic"
  [toggleable]="false"
  class="small-menu-panel"
  styleClass="tw-fixed tw-left-0 tw-top-0 tw-w-20 tw-h-full tw-items-center tw-shadow-lg tw-border-l-0 tw-border-t-0 tw-border-b-0 tw-border-r-2 tw-border-gray-200 tw-cursor-pointer hover:tw-w-24 tw-transition-all tw-duration-200 tw-rounded-none"
  (click)="openSidebar($event)"
>
  <ng-template pTemplate="header">
    <div class="tw-flex tw-justify-center tw-w-full tw-mt-[0.4rem]">
      <a [href]="appUrls['burthub']">
        <img
          class="tw-h-7"
          src="assets/images/svg/b-logo.svg"
        />
      </a>
    </div>
  </ng-template>

  <div class="tw-flex-grow tw-mb-16 tw-flex tw-flex-col tw-mt-2 tw-items-center tw-gap-3 tw-overflow-hidden tw-min-h-0">
    <div
      #itemsContainer
      class="tw-flex-grow tw-flex tw-flex-col tw-items-center tw-gap-3 tw-overflow-hidden tw-w-full tw-min-h-0"
    >
      <a
        *ngFor="let item of visibleItems"
        class="tw-py-2 tw-px-4 tw-rounded-md tw-flex-shrink-0"
        [ngClass]="{ 'tw-bg-burt-purple': currentApp.app === item.appKey }"
        [pTooltip]="item.label"
        tooltipPosition="right"
        [href]="item.url"
        (click)="item.command && item.command()"
      >
        <span
          [class]="item.icon"
          [ngClass]="currentApp.app === item.appKey ? 'tw-text-surface-50' : 'tw-text-surface-500'"
          class="tw-text-xl"
        ></span>
      </a>
      <p-button
        *ngIf="hasMoreItems"
        [text]="true"
        size="large"
        severity="secondary"
        icon="fa-solid fa-ellipsis-vertical"
        pTooltip="More apps"
        tooltipPosition="right"
        (onClick)="openSidebar($event)"
      ></p-button>
    </div>
  </div>

  <div
    class="panel-footer tw-flex-grow-0 tw-flex tw-items-center tw-flex-col tw-gap-4 tw-transition-all tw-duration-200"
  >
    <a
      class="tw-cursor-pointer shadow"
      [href]="'https://status.burtintelligence.com'"
      target="_blank"
      (click)="onStatusButtonClick()"
    >
      <span
        class="tw-text-xl tw-text-surface-500 fa-regular fa-monitor-waveform"
        pTooltip="Status"
        tooltipPosition="right"
      ></span>
    </a>
    <a
      *ngIf="isBurtAdmin"
      class="tw-cursor-pointer shadow"
      [href]="getSolidQueueUrl()"
      target="_blank"
    >
      <span
        class="tw-text-xl tw-text-surface-500 fa-regular fa-list-check"
        pTooltip="Job Queue"
        tooltipPosition="right"
      ></span>
    </a>

    <p-divider />

    <p-avatar
      styleClass="tw-bg-red-100 tw-text-white"
      [label]="userInitials"
      size="large"
      shape="circle"
    ></p-avatar>
  </div>
</p-panel>

<p-sidebar
  *ngIf="!isPublic"
  #sidebarRef
  styleClass="tw-shadow-lg"
  class="sidebar-menu"
  [showCloseIcon]="false"
  [(visible)]="sidebarVisible"
>
  <ng-template pTemplate="header">
    <a [href]="appUrls['burthub']">
      <img
        class="tw-h-12 tw-ml-2 tw-mt-2"
        src="assets/images/b-logo-full.png"
      />
    </a>
  </ng-template>
  <ng-template pTemplate="content">
    <p-panelMenu
      [model]="items"
      [multiple]="true"
      styleClass="tw-mt-[0.3rem] tw-ml-2"
    >
      <ng-template
        pTemplate="item"
        let-item
      >
        <ng-container>
          <a
            stopClickPropagation
            [href]="item.url"
            class="tw-cursor-pointer"
          >
            <span
              stopClickPropagation
              *ngIf="item.icon"
              class="tw-text-burt-purple"
              [class]="item.icon"
            ></span>
            <span
              stopClickPropagation
              [ngClass]="{
                'tw-font-semibold tw-text-burt-purple': item.icon && !(!item.items && currentApp.app === item.appKey),
                'tw-text-burt-purple tw-font-bold':
                  item.url === currentUrl || (!item.items && currentApp.app === item.appKey),
                'tw-font-medium tw-text-gray-600':
                  !item.icon && item.url !== currentUrl && !(!item.items && currentApp.app === item.appKey),
              }"
            >
              {{ item.label }}
            </span>
          </a>
        </ng-container>
      </ng-template>
    </p-panelMenu>
  </ng-template>
  <ng-template pTemplate="footer">
    <a
      class="tw-cursor-pointer tw-ml-3 tw-block tw-w-full tw-py-2 tw-px-2 hover:tw-bg-gray-100 tw-rounded"
      [href]="'https://status.burtintelligence.com'"
      target="_blank"
      (click)="onStatusButtonClick()"
    >
      <span class="tw-mr-[0.4rem] tw-text-lg tw-text-burt-purple fa-regular fa-monitor-waveform"></span>
      <span class="tw-text-gray-600 tw-font-semibold">Status</span>
    </a>
    <a
      *ngIf="isBurtAdmin"
      class="tw-cursor-pointer tw-ml-3 tw-block tw-w-full tw-py-2 tw-px-2 hover:tw-bg-gray-100 tw-rounded"
      [href]="getSolidQueueUrl()"
      target="_blank"
    >
      <span class="tw-mr-[0.4rem] tw-text-lg tw-text-burt-purple fa-regular fa-list-check"></span>
      <span class="tw-text-gray-600 tw-font-semibold">Job Queue</span>
    </a>
    <p-divider />
    <div class="tw-flex tw-justify-between tw-items-center">
      <div class="tw-flex tw-ml-2 tw-items-center">
        <div class="tw-mr-2">
          <p-avatar
            styleClass="tw-bg-red-100 tw-text-white"
            [label]="userInitials"
            size="large"
            shape="circle"
          ></p-avatar>
        </div>
        <div class="tw-break-all">
          <div class="tw-font-semibold">{{ user.name }}</div>
          <div
            *ngIf="isBurtAdmin"
            class="tw-text-xs tw-font-semibold"
          >
            {{ account.name }}
          </div>
          <div class="tw-text-xs tw-font-normal">{{ user.suite }}</div>
        </div>
      </div>
      <hub-main-menu></hub-main-menu>
    </div>
  </ng-template>
</p-sidebar>
<div class="tw-flex tw-items-center tw-ml-8 tw-gap-4 tw-text-gray-700 tw-w-full tw-justify-between">
  <div class="tw-flex tw-items-center">
    <span
      class="tw-text-xl tw-mr-2 fa-solid"
      [class]="appIcons[currentApp.app]"
    ></span>
    <a [routerLink]="!isPublic ? ['/'] : []">
      <span
        *ngIf="currentApp.app !== 'home'"
        class="tw-text-2xl tw-font-semibold"
      >
        {{ currentApp.title }}
      </span>
    </a>
    <span
      *ngIf="currentApp.app === 'home'"
      class="tw-text-2xl tw-font-semibold"
    >
      Welcome,
      <span class="tw-font-bold tw-text-burt-purple">{{ user.name }}</span>!
    </span>
  </div>
  <div class="tw-mr-8">
    <morph-menu></morph-menu>
  </div>
</div>

<p-dialog
  [(visible)]="showConfigDialog"
  [modal]="true"
  [style]="{ width: '450px' }"
  header="Select Forecasting Instance"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
>
  <div class="tw-flex tw-flex-col tw-gap-4">
    <ng-container *ngIf="forecastingAppSelected">
      <div
        *ngFor="let config of getForecastingConfigurations()"
        class="tw-flex tw-justify-between tw-items-center tw-p-4 tw-border tw-rounded"
      >
        <span class="tw-font-medium">{{ config.entityName }}</span>
        <a
          [href]="config.url"
          target="_blank"
          class="tw-text-blue-600 hover:tw-text-blue-800"
        >
          <i class="pi pi-external-link tw-mr-2"></i>
          Open
        </a>
      </div>
    </ng-container>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      label="Close"
      (click)="showConfigDialog = false"
    ></p-button>
  </ng-template>
</p-dialog>
